module.exports = {
      id: "comm-world-cup-usage",
      viewBox: "0 0 411.122 51.012",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-world-cup",
      toString: function () {
        return this.url;
      }
    }